import { openDB } from 'idb';
let authDB = null;
const initAuthDB = async () => {
    if (!authDB) {
        authDB = await openDB('authDB', 1, {
            upgrade(db) {
                console.log(db, db.objectStoreNames.contains('tokens'));
                if (!db.objectStoreNames.contains('tokens')) {
                    db.createObjectStore('tokens');
                }
            },
        });
    }
    return authDB;
};
export const fetchToken = async (key) => {
    const db = await initAuthDB();
    return await db.get('tokens', key);
};
export const saveToken = async (key, value) => {
    const db = await initAuthDB();
    await db.put('tokens', value, key);
};
export const removeToken = async (key) => {
    const db = await initAuthDB();
    await db.delete('tokens', key);
};
